module.exports = __webpack_public_path__ + "static/client_10-b1a84c7e73b614fb75f19ff02e7d7ceb.png";